import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/transfer-webchat.vue
var o = {
	name: "DtIconTransferWebchat",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--transfer-webchat"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Transfer Webchat",
		viewBox: "0 0 12 12",
		xmlns: "http://www.w3.org/2000/svg"
	}, [...t[0] || (t[0] = [r("path", {
		d: "M1 7.962a.5.5 0 1 1 1 0v2.293l1.146-1.147.077-.062a.5.5 0 0 1 .277-.084h6a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 1 0-1h2a1.5 1.5 0 0 1 1.5 1.5v5a1.5 1.5 0 0 1-1.5 1.5H3.707l-1.853 1.853A.5.5 0 0 1 1 11.462v-3.5Zm.396-4.874a.5.5 0 0 1 .772.629l-.064.078-.01.009-.024.025-.093.093-.27.27H3.5a.5.5 0 0 1 0 1H1.707l.397.396a.5.5 0 1 1-.708.707l-1.25-1.25a.5.5 0 0 1 0-.707L1.27 3.215l.092-.094.026-.024.008-.01Zm2.5-2.98a.5.5 0 0 1 .708 0l1.25 1.25a.5.5 0 0 1 0 .707l-1.25 1.25a.5.5 0 1 1-.708-.707l.397-.396H2.5a.5.5 0 0 1 0-1h1.793L3.896.815a.5.5 0 0 1 0-.707Z",
		fill: "currentColor"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=transfer-webchat.js.map